import React, {useEffect} from 'react';

import './contacts-scroll-button.scss';


const ContactsScrollButton = () => {
  const express = React.useRef()

  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());
  const eng = window.lang && window.lang === 'en' || (params.lang && (params.lang === 'en'));
  const requestDesign = eng ? 'Request a design...' : 'Заказать дизайн...'

  const scrollToContacts = (evt) => {
    if (evt) {
      evt.preventDefault();
    }

    if (window.ym) {
      if (window.location.pathname === '/competencies/interface/apps/') {
        window.ym(5320750,'reachGoal','click_button_1');
      } else if (window.location.pathname === '/competencies/interface/') {
        window.ym(5320750,'reachGoal','click_button_2');
      }
    }

    window.scrollTo({
      top: document.querySelector('#contact').offsetTop,
      behavior: 'smooth',
    });

    window.history.replaceState({}, '', '#contact');
  };

  const showExpress = () => {
    const contact = document.querySelector('#contact')
    const firstTargetScreen = document.querySelector('.content-block-0')

    if(
      contact?.getBoundingClientRect().top - window.innerHeight < 0 ||
      firstTargetScreen?.getBoundingClientRect().top > window.innerHeight/2
    ){
      express.current.classList.add('hidden-express')
    }else{
      express.current.classList.remove('hidden-express')
    }
  }

  useEffect(() => {
    showExpress()

    if (window.location.hash === '#contact') {
      scrollToContacts();
    }

    const onScroll = () => {
      showExpress()
    }

    window.addEventListener('scroll', onScroll)
    return () => {
      window.removeEventListener('scroll', onScroll)
    }
  });



  return (
      <div className="express-form hidden-express" ref={express}>
        <a href="#contact" onClick={scrollToContacts}>{requestDesign}</a>
      </div>
  );
}

export default ContactsScrollButton;
